import { UploadProps } from 'antd';

export const config: UploadProps = {
  accept: '.png, .jpg, .jpeg, .webp',
  multiple: true,
  listType: 'picture',
};
